import { render, staticRenderFns } from "./BlastList.vue?vue&type=template&id=3a6b2854&scoped=true&"
import script from "./BlastList.vue?vue&type=script&lang=js&"
export * from "./BlastList.vue?vue&type=script&lang=js&"
import style0 from "./BlastList.vue?vue&type=style&index=0&id=3a6b2854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6b2854",
  null
  
)

export default component.exports